import React from 'react';

import styles from './savedListItem.scss';

const SavedListItem = (props) => {
    const isDefaultList = props.data && (props.data.name === 'Default'); // Allow delete when not a default list
    return (
        <div
            className={`d-flex flex-row flex-nowrap align-items-stretch ${styles.container}`}
        >
            <div
                className={`${styles.name}`}
                onClick={() => props.onListSelected(props.data, props.listType)}
            >
                {props.data.name}
            </div>
            {!isDefaultList && (
                <button
                    type="button"
                    className={`btn btn-default btn-sm ${styles.remove}`}
                    onClick={() => props.onListDeleted(props.data, props.listType)}
                >
                    <span className={`fas fa-times`} />
                </button>
            )}
        </div>

    );
};

export default SavedListItem;
